angular.module('hybrid-ng-personal-reminders').component('expandingReminderTextbox', {
  controller: 'ExpandingReminderTextboxController',
  templateUrl: 'hybrid-ng-personal-reminders/src/components/expanding_reminder_textbox/expanding_reminder_textbox.html'
});



// WEBPACK FOOTER //
// ./app/vendor/hybrid-ng-personal-reminders/src/components/expanding_reminder_textbox/expanding_reminder_textbox_component.ts